export class PlumbingFixtureLayout {
	public fields = [{ fieldName: 'fixtureType', label: 'Type' }];
}
